<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="1200px"
    top="10vh"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :disabled="disabled"
      :amzReplenishmentDetailCode="amzReplenishmentDetailCode"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="danger"
        size="small"
        @click="$refs.main.stopReplenishment()"
        v-if="!disabled"
      >
        {{ $l('btn_stopReplenishment') || '该产品不再补货' }}
      </el-button>
      <el-button
        type="warning"
        size="small"
        @click="$refs.main.del()"
        v-if="!disabled"
      >
        {{ $l('INDEX.btn_rep_cancel') || '不补货' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="$refs.main.save()"
        v-if="!disabled"
      >
        {{ $l('INDEX.btn_rep_save') || '保存' }}
      </el-button>
      <el-button
        v-if="!disabled"
        type="success"
        size="small"
        @click="$refs.main.save({ isSaveAndSubmit: 'Y' })"
      >
        {{ $l('INDEX.btn_rep_save_submit') || '保存并提交' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    amzReplenishmentDetailCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
